import { render, staticRenderFns } from "./PopupDetailNotice.vue?vue&type=template&id=30ff295e"
import script from "./PopupDetailNotice.vue?vue&type=script&lang=js"
export * from "./PopupDetailNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports